// index.js
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Footer from './components/presentation/components/Footer';
import Dashboard from './components/presentation/Dashboard';
import PageList from './enum/PageList';
import Navigator from './logic/navigator';
import TestInstanceManagementWidget from './components/container/TestInstanceManagementWidget';
import ScenarioManagementWidget from './components/container/ScenarioManagementWidget';
import DeviceManagementWidget from './components/container/DeviceManagementWidget';
import ClusterManagementWidget from './components/container/ClusterManagementWidget';
import CreateClusterWidget from './components/container/CreateClusterWidget';
import EditClusterWidget from './components/container/EditClusterWidget';
import EditTestInstanceWidget from './components/container/EditTestInstanceWidget';
import AddDevicesToTestWidget from './components/container/AddDevicesToTestWidget';
import EditAddDevicesToTestWidget from './components/container/EditAddDevicesToTestWidget';
import CompletedTestInstanceListWidget from './components/container/CompletedTestInstanceListWidget';
import CompareTestInstancesWidget from './components/container/CompareTestInstancesWidget';
import AnalyticsWidget from './components/container/AnalyticsWidget';
import MapAnalyticsWidget from './components/container/MapAnalyticsWidget';
import MatrixAnalysisWidget from './components/container/MatrixAnalysisWidget';
import StartupAnalysisWidget from './components/container/StartupAnalysisWidget';
import BatteryStatsWidget from './components/container/BatteryStatsWidget';
import EditScenarioWidget from './components/container/EditScenarioWidget';
import ZonesImportWidget from './components/container/ZonesImportWidget';
import EditDeviceWidget from './components/container/EditDeviceWidget';
import ScenarioTypes from './enum/ScenarioEnum';

class MainInterface extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: PageList.testInstanceManagement,
            pageParameters: [],
            device: '',
            cluster: '',
            testInstance: '',
            testInstanceDevices: [],
            clusterDevices: [],
            showRemoteConfig: false,
            compareOptions: {},
        };

        this.navigator = new Navigator(this);
    }

    componentDidMount() {
        this.loadPageFromURL();

        window.onpopstate = () => {
            this.loadPageFromURL();
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.currentPage && prevState.currentPage !== this.state.currentPage) {
            var url = '/' + this.state.currentPage.name;
            if (this.state.pageParameters != null) {
                for (var i = 0; i < this.state.pageParameters.length; i++) {
                    url += '/' + this.state.pageParameters[i];
                }
            }
            window.scroll(0, 0);
            window.history.pushState(null, this.state.currentPage.title, url);
        } else if (this.state.currentPage && prevState.pageParameters !== this.state.pageParameters) {
            var url = '/' + this.state.currentPage.name;
            if (this.state.pageParameters != null) {
                for (var i = 0; i < this.state.pageParameters.length; i++) {
                    url += '/' + this.state.pageParameters[i];
                }
            }
            window.history.replaceState(null, this.state.currentPage.title, url);
        }
    }

    loadPageFromURL = stateObj => {
        if (!stateObj) stateObj = {};
        let pageName = document.location.pathname.substring(1);
        let section = pageName.indexOf('/');
        let pageParameters = [];
        if (section > 0) {
            pageParameters = pageName.split('/').slice(1);
            pageName = pageName.substr(0, section);
        }
        stateObj.currentPage = PageList[pageName];
        stateObj.pageParameters = pageParameters;
        this.setState(stateObj);
    };

    updateTestInstance = testInstance => {
        this.setState({ testInstance });
    };

    updateTestDevices = testInstanceDevices => {
        this.setState({ testInstanceDevices });
    };

    updateCluster = (cluster, clusterDevices) => {
        this.setState({ cluster: cluster, clusterDevices: clusterDevices });
    };

    render() {
        let mainWidget;
        const { pageParameters, currentPage, testInstanceDevices } = this.state;
        let activeView = (
            <TestInstanceManagementWidget
                navigator={this.navigator}
                updateTestInstance={this.updateTestInstance}
                updateTestDevices={this.updateTestDevices}
            />
        );
        /** Analytics */
        if (currentPage === PageList.analytics || currentPage === PageList.matrixAnalysis) {
            let activeAnalytics = <MatrixAnalysisWidget navigator={this.navigator} pageParameters={pageParameters} />;
            activeView = (
                <AnalyticsWidget
                    navigator={this.navigator}
                    activeAnalytics={activeAnalytics}
                    pageParameters={pageParameters}
                />
            );
        }

        if (currentPage === PageList.batteryStats) {
            let activeBatteryStats = <BatteryStatsWidget navigator={this.navigator} pageParameters={pageParameters} />;
            let activeAnalytics = (
                <BatteryStatsWidget
                    navigator={this.navigator}
                    activeBatteryStats={activeBatteryStats}
                    pageParameters={pageParameters}
                />
            );
            activeView = (
                <AnalyticsWidget
                    navigator={this.navigator}
                    activeAnalytics={activeAnalytics}
                    pageParameters={pageParameters}
                />
            );
        }

        if (currentPage === PageList.mapAnalytics) {
            let activeAnalytics = <MapAnalyticsWidget navigator={this.navigator} pageParameters={pageParameters} />;
            activeView = (
                <AnalyticsWidget
                    navigator={this.navigator}
                    activeAnalytics={activeAnalytics}
                    pageParameters={pageParameters}
                />
            );
        }

        /** Scenario Management */
        if (currentPage === PageList.scenarioManagement) {
            activeView = <ScenarioManagementWidget navigator={this.navigator} />;
        }

        if (currentPage === PageList.addNewScenario) {
            activeView = <EditScenarioWidget navigator={this.navigator} />;
        }

        if (currentPage === PageList.editScenario) {
            activeView = <EditScenarioWidget navigator={this.navigator} pageParameters={pageParameters} />;
        }

        if (currentPage === PageList.zonesImport) {
            activeView = <ZonesImportWidget navigator={this.navigator} pageParameters={pageParameters} />;
        }

        /** Device Management */
        if (currentPage === PageList.deviceManagement) {
            activeView = <DeviceManagementWidget navigator={this.navigator} />;
        }

        if (currentPage === PageList.addNewDevice) {
            activeView = <EditDeviceWidget EditScenarioWidget navigator={this.navigator} />;
        }

        if (currentPage === PageList.editDevice) {
            activeView = <EditDeviceWidget navigator={this.navigator} pageParameters={pageParameters} />;
        }

        /** Cluster Management */

        if (currentPage === PageList.clusterManagement) {
            activeView = <ClusterManagementWidget navigator={this.navigator} updateCluster={this.updateCluster} />;
        }

        if (currentPage === PageList.createCluster) {
            activeView = <CreateClusterWidget navigator={this.navigator} />;
        }

        if (currentPage === PageList.editCluster) {
            activeView = <EditClusterWidget navigator={this.navigator} pageParameters={pageParameters} />;
        }

        /** Test Instance Management */
        if (currentPage === PageList.addNewTestInstance) {
            activeView = (
                <EditTestInstanceWidget 
                navigator={this.navigator} 
                getTestInstanceDevices={testInstanceDevices}
                pageParameters={pageParameters} />
            );
        }

        if (currentPage === PageList.editTestInstance) {
            activeView = (
                <EditTestInstanceWidget
                    navigator={this.navigator}
                    updateTestDevices={this.updateTestDevices}
                    pageParameters={pageParameters}
                />
            );
        }

        if (currentPage === PageList.addDevicesToTest) {
            activeView = (
                <AddDevicesToTestWidget navigator={this.navigator} updateTestDevices={this.updateTestDevices} />
            );
        }

        if (currentPage === PageList.editAddDevicesToTest) {
            activeView = (
                <EditAddDevicesToTestWidget
                    navigator={this.navigator}
                    updateTestDevices={this.updateTestDevices}
                    getTestInstanceDevices={testInstanceDevices}
                    pageParameters={pageParameters}
                />
            );
        }

        /** Completed Test Instance */
        if (currentPage === PageList.analyticsTestInstanceList) {
            activeView = <CompletedTestInstanceListWidget navigator={this.navigator} />;
        }

        if (currentPage === PageList.compareTestInstances) {
            activeView = (
                <CompareTestInstancesWidget
                    navigator={this.navigator}
                    pageParameters={pageParameters}
                    options={this.state.compareOptions}
                />
            );
        }

        mainWidget = (
            <div>
                <Dashboard activeView={activeView} navigator={this.navigator} />
            </div>
        );

        if (currentPage) {
            document.title = currentPage.title + ' | Bluedot Test Management Portal';
        }

        return (
            <div>
                <div>{mainWidget}</div>
                <Footer />
            </div>
        ); //return
    } //render
} //MainInterface

ReactDOM.render(<MainInterface />, document.getElementById('mainContent'));
